import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useDrop } from "react-dnd";
import { IProductCardItem } from "../productCard/ProductCard";
import { ProductCardsItemTypes } from "../ProductCards";
import "./productCardSlot.scss";

interface IProductCardSlotProps {
  position: number;
  isPositionInASelectedRow: (position: number) => boolean;
  selectEmptyCard: (event: React.MouseEvent<HTMLDivElement>, position: number) => void;
  onChangeProductPosition: (id: number, position: number) => void;
}

export default function ProductCardSlot(props: IProductCardSlotProps) {
  const { position, isPositionInASelectedRow, selectEmptyCard, onChangeProductPosition } = props;

  const [{ isOver }, drop] = useDrop(
    () => ({
      accept: ProductCardsItemTypes.PRODUCT_CARD,
      drop: (item: IProductCardItem) => {
        onChangeProductPosition(item.id, position);
      },
      collect: monitor => ({
        isOver: !!monitor.isOver(),
      }),
    }),
    [],
  );

  return (
    <div
      ref={drop}
      className={`product-card-container${isOver ? " product-card-container--drop-target" : ""}`}
    >
      <div
        style={{ ...(isPositionInASelectedRow(position) ? { backgroundColor: "blue" } : {}) }}
        onClick={e => selectEmptyCard(e, position)}
        className="product-card-slot"
      >
        <FontAwesomeIcon className="product-card-slot-add-product-icon" icon={["far", "plus"]} />
      </div>
      {isOver ? <div className="product-card-drop-target-ring" aria-hidden /> : null}
    </div>
  );
}
